import React from 'react';
import { useTranslation } from 'react-i18next';
import { BRAND_ICON_SRC, BRAND_LOGO_SRC } from '@/constants/brand';

/** Full wordmark — contracts, light backgrounds, auth cards. */
export function BrandLogo({ className = 'h-12 w-auto', alt }) {
  const { t } = useTranslation();
  return <img src={BRAND_LOGO_SRC} alt={alt ?? t('app_logo_alt')} className={className} />;
}

/** Square app icon — dark sidebars, landing nav tiles, favicon source. */
export function BrandIcon({ className = 'h-12 w-12', alt }) {
  const { t } = useTranslation();
  return <img src={BRAND_ICON_SRC} alt={alt ?? t('app_logo_alt')} className={className} />;
}

/** Icon + wordmark for dark backgrounds (sidebars). */
export function BrandMark({ iconClassName = 'h-12 w-12', textClassName = 'text-3xl font-bold text-white', subtitle }) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-3">
      <BrandIcon className={iconClassName} />
      <div>
        <div className={textClassName}>AutoGo</div>
        {subtitle}
      </div>
    </div>
  );
}
